import { Grid, GridItem, Heading } from "@chakra-ui/react";
import { ofiBankGiro, ofiEmail, ofiSwishNr } from "./foreningen";
import { Postings } from "./Posts/Postings";

function Start() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="app">
      <Postings
        showLegend={true}
        category="mainpage"
        alias={{
          year: `${currentYear}`,
          email: `${ofiEmail}`,
          bankgiro: `${ofiBankGiro}`,
          swish: `${ofiSwishNr}`,
        }}
      />
    </div>
  );
}

export default Start;
